<!-- eslint-disable -->
<template lang="pug">
    div
        .table-container
            table
                tr.list
                    td.list-item.list-item__date
                        .list-item.list-item-header
                            | {{ $i18n.t('list.list_homeworkPreview_exerciseDate') }}
                            | {{ homework.date | moment('DD.MM.YYYY') }}
                    td.list-item
                        .list-item-header
                            | {{ $i18n.t('list.list_homeworkPreview_exercises') }}:
                        .list-item__games
                            div(v-for='exercise in homework.exercises' :title='getGameSettingsTitle(exercise)')
                                | {{ getGameName(exercise) }}
                    td.list-item.list-item__students
                        .list-item-header
                            | {{ $i18n.t('list.list_homeworkPreview_forUsers') }}:
                        div
                            div(v-for='user in homework.users')
                                | {{ user.firstName }} {{ user.lastName }}
                    td.list-item.list-item__actions
                        .actions
                            dropdown(:icon='false', without-move)
                                template(slot="link")
                                    svg-icon.homework-preview__icon.homework-preview__icon_blue(name="select", :size="selectorSize")
                                ul.menu-list
                                    li
                                        router-link.action.actions__edit(
                                            v-if='!editAndCopyShouldBeHided'
                                            :to="{name: 'homework:edit',params: {id: profile.id, type: 'homework'}}"
                                        )
                                            | {{ $i18n.t('list.list_common_actionsEdit') }}
                                    li
                                        router-link.action.actions__copy(
                                            v-if="!editAndCopyShouldBeHided"
                                            :to="{name: 'homework:create', params: {copy: profile, type: 'homework'}}")
                                            | {{ $i18n.t('list.list_homeworkPreview_actionsCopy') }}
                                    li
                                        a.action.actions__delete(@click='displayConfirmDeleteModal = true')
                                            | {{ $i18n.t('list.list_common_actionsDelete') }}
        divider(:margin="'10px auto'")
        confirm-delete-modal(
            v-if='displayConfirmDeleteModal',
            @close='displayConfirmDeleteModal = false',
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_homeworkPreview_thisHomework') }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import ProgressPreviewMixin from '../../../utils/progressPreviewMixin';
    import { mapState } from 'vuex';
    import { TARIFF_IDS_WITH_HOMEWORK_LIMIT } from '@/config/tariff_constants';
    const ConfirmDeleteModal = () => import('../../../modals/ConfirmDeleteModal.vue');

    export default {
        props: {
            profile: Object,
        },
        data () {
            return {
                displayConfirmDeleteModal: false,
            }
        },
        components: {
            Dropdown,
            ConfirmDeleteModal,
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            editAndCopyShouldBeHided() {
                return this.user.type === 'teacher' && TARIFF_IDS_WITH_HOMEWORK_LIMIT.includes(this.user.schools[0].tariffId);
            },
            homework() {
                return this.profile;
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            }
        },
        mixins: [TrainerUtilities, ProgressPreviewMixin]
    }
</script>

<style lang="scss" scoped>
    .table-container {
        overflow: auto;
        table {
            width: 100%;
            min-height: 210px;
            @media screen and (max-width: 767px) {
                min-width: 768px;
            }
        }
    }
    .list {
        justify-content: space-between;
        margin: 20px 30px;
        font-weight: normal;
    }
    .list-item {
        vertical-align: top;
    }
    .list-item-header {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
    }
    .list-item__date {
        width: 20%;
    }
    .list-item__games {
        width: 100%;
        text-align: left;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        @media screen and (max-width: 767px) {
            text-align: center;
        }
    }
    .list-item__students {
        width: 30%;
    }
    .list-item__actions {
        width: 5%;
    }
    .actions {
        display: flex;
        align-items: center;
        text-align: left;
        .menu-list {
            li {
                margin: 7px 0;
            }
        }
        .action {
            cursor: pointer;
            font-size: 16px;
            line-height: 26px;
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
    .actions__link {
        display: flex;
        align-items: center;
    }
    .homework-preview__icon_blue {
        color: $hsl-color-blue-56;
    }
</style>
